module.exports = __webpack_public_path__ + "static/media/lavandoMaos.c770c130.svg";